export default __webpack_public_path__ + "static/media/shared-with-me-icon.b4bc3dba.svg";